export interface ErrorInfo {
  code: string | number,
  message: string,
  correlationId?: string
}

interface APIException {
  Error?: {
    Code: string | number,
    Message: string
  },
  error?: {
    code: string | number,
    message: string
  }
}

function isAPIException(x: any) : x is APIException {
  return x && x.Error && x.Error.Code && x.Error.Message ||
    x && x.error && x.error.code && x.error.message;
}

function asAPIException(xhr: JQueryXHR) : APIException {
  return isAPIException(xhr.responseJSON) ? xhr.responseJSON : null;
}

function parseApiException(ex: APIException) : ErrorInfo {
  let code = ex.Error ? ex.Error.Code : ex.error.code;
  let message: string = null;
  if (ex.Error && ex.Error.Message) {
    message = ex.Error.Message;
  } else if (ex.error && ex.error.message) {
    message = ex.error.message;
  }
  if (message) {
    try {
      const obj = JSON.parse(message);
      if (isAPIException(obj)) {
        return parseApiException(obj);
      }
    } catch (jsonex) {
      // ignore error;
    }
  }
  return {code: code, message: message};
}

export function parseApiError(xhr: JQueryXHR) : ErrorInfo {
  const apiException = asAPIException(xhr);
  if (apiException) {
    return parseApiException(apiException);
  }
  if (xhr.responseJSON && xhr.responseJSON.Message) {
    return {code: xhr.status, message: xhr.responseJSON.Message};
  }
  return null;
}


// WEBPACK FOOTER //
// ./Client/v4/Services/parseApiError.ts